























import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputCheckbox extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    @Prop({ default: true }) readonly trueValue: string|boolean
    @Prop({ default: false }) readonly falseValue: string|boolean
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: string = null

    created() {
        this.onExternalChange()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange(): void {
        this.$emit('input', this.internalValue)
    }

    get isChecked(): boolean {
        return this.internalValue === this.trueValue
    }

    get componentClass(): object {
        return {
            'input-checkbox': true,
            'input-checkbox--checked': this.isChecked,
        }
    }
}
